export const HOME_FETCH_MEMBERS_BEGIN = 'HOME_FETCH_MEMBERS_BEGIN';
export const HOME_FETCH_MEMBERS_SUCCESS = 'HOME_FETCH_MEMBERS_SUCCESS';
export const HOME_FETCH_MEMBERS_FAILURE = 'HOME_FETCH_MEMBERS_FAILURE';
export const HOME_FETCH_MEMBERS_DISMISS_ERROR = 'HOME_FETCH_MEMBERS_DISMISS_ERROR';
export const HOME_FETCH_PHASES_BEGIN = 'HOME_FETCH_PHASES_BEGIN';
export const HOME_FETCH_PHASES_SUCCESS = 'HOME_FETCH_PHASES_SUCCESS';
export const HOME_FETCH_PHASES_FAILURE = 'HOME_FETCH_PHASES_FAILURE';
export const HOME_FETCH_PHASES_DISMISS_ERROR = 'HOME_FETCH_PHASES_DISMISS_ERROR';
export const HOME_DELETE_PROJECT_BEGIN = 'HOME_DELETE_PROJECT_BEGIN';
export const HOME_DELETE_PROJECT_SUCCESS = 'HOME_DELETE_PROJECT_SUCCESS';
export const HOME_DELETE_PROJECT_FAILURE = 'HOME_DELETE_PROJECT_FAILURE';
export const HOME_DELETE_PROJECT_DISMISS_ERROR = 'HOME_DELETE_PROJECT_DISMISS_ERROR';
export const HOME_SAVE_PROJECT = 'HOME_SAVE_PROJECT';
export const HOME_SAVE_PROJECT_ACTION_BEGIN = 'HOME_SAVE_PROJECT_ACTION_BEGIN';
export const HOME_SAVE_PROJECT_ACTION_SUCCESS = 'HOME_SAVE_PROJECT_ACTION_SUCCESS';
export const HOME_SAVE_PROJECT_ACTION_FAILURE = 'HOME_SAVE_PROJECT_ACTION_FAILURE';
export const HOME_SAVE_PROJECT_ACTION_DISMISS_ERROR = 'HOME_SAVE_PROJECT_ACTION_DISMISS_ERROR';
export const HOME_FETCH_SCOPE_BY_PROJECT_BEGIN = 'HOME_FETCH_SCOPE_BY_PROJECT_BEGIN';
export const HOME_FETCH_SCOPE_BY_PROJECT_SUCCESS = 'HOME_FETCH_SCOPE_BY_PROJECT_SUCCESS';
export const HOME_FETCH_SCOPE_BY_PROJECT_FAILURE = 'HOME_FETCH_SCOPE_BY_PROJECT_FAILURE';
export const HOME_FETCH_SCOPE_BY_PROJECT_DISMISS_ERROR = 'HOME_FETCH_SCOPE_BY_PROJECT_DISMISS_ERROR';
export const HOME_GET_NEXT_PROJECT_ID_BEGIN = 'HOME_GET_NEXT_PROJECT_ID_BEGIN';
export const HOME_GET_NEXT_PROJECT_ID_SUCCESS = 'HOME_GET_NEXT_PROJECT_ID_SUCCESS';
export const HOME_GET_NEXT_PROJECT_ID_FAILURE = 'HOME_GET_NEXT_PROJECT_ID_FAILURE';
export const HOME_GET_NEXT_PROJECT_ID_DISMISS_ERROR = 'HOME_GET_NEXT_PROJECT_ID_DISMISS_ERROR';
export const HOME_FETCH_CURRENCIES_BEGIN = 'HOME_FETCH_CURRENCIES_BEGIN';
export const HOME_FETCH_CURRENCIES_SUCCESS = 'HOME_FETCH_CURRENCIES_SUCCESS';
export const HOME_FETCH_CURRENCIES_FAILURE = 'HOME_FETCH_CURRENCIES_FAILURE';
export const HOME_FETCH_CURRENCIES_DISMISS_ERROR = 'HOME_FETCH_CURRENCIES_DISMISS_ERROR';
export const HOME_FETCH_CLOSE_OUT_BEGIN = 'HOME_FETCH_CLOSE_OUT_BEGIN';
export const HOME_FETCH_CLOSE_OUT_SUCCESS = 'HOME_FETCH_CLOSE_OUT_SUCCESS';
export const HOME_FETCH_CLOSE_OUT_FAILURE = 'HOME_FETCH_CLOSE_OUT_FAILURE';
export const HOME_FETCH_CLOSE_OUT_DISMISS_ERROR = 'HOME_FETCH_CLOSE_OUT_DISMISS_ERROR';
export const HOME_SAVE_CLOSE_OUT_BEGIN = 'HOME_SAVE_CLOSE_OUT_BEGIN';
export const HOME_SAVE_CLOSE_OUT_SUCCESS = 'HOME_SAVE_CLOSE_OUT_SUCCESS';
export const HOME_SAVE_CLOSE_OUT_FAILURE = 'HOME_SAVE_CLOSE_OUT_FAILURE';
export const HOME_SAVE_CLOSE_OUT_DISMISS_ERROR = 'HOME_SAVE_CLOSE_OUT_DISMISS_ERROR';
export const HOME_FETCH_RESUME_BEGIN = 'HOME_FETCH_RESUME_BEGIN';
export const HOME_FETCH_RESUME_SUCCESS = 'HOME_FETCH_RESUME_SUCCESS';
export const HOME_FETCH_RESUME_FAILURE = 'HOME_FETCH_RESUME_FAILURE';
export const HOME_FETCH_RESUME_DISMISS_ERROR = 'HOME_FETCH_RESUME_DISMISS_ERROR';
export const HOME_CLONE_PROJECT_BEGIN = 'HOME_CLONE_PROJECT_BEGIN';
export const HOME_CLONE_PROJECT_SUCCESS = 'HOME_CLONE_PROJECT_SUCCESS';
export const HOME_CLONE_PROJECT_FAILURE = 'HOME_CLONE_PROJECT_FAILURE';
export const HOME_CLONE_PROJECT_DISMISS_ERROR = 'HOME_CLONE_PROJECT_DISMISS_ERROR';
export const HOME_GET_CLOSE_OUT_REPORT_BEGIN = 'HOME_GET_CLOSE_OUT_REPORT_BEGIN';
export const HOME_GET_CLOSE_OUT_REPORT_SUCCESS = 'HOME_GET_CLOSE_OUT_REPORT_SUCCESS';
export const HOME_GET_CLOSE_OUT_REPORT_FAILURE = 'HOME_GET_CLOSE_OUT_REPORT_FAILURE';
export const HOME_GET_CLOSE_OUT_REPORT_DISMISS_ERROR = 'HOME_GET_CLOSE_OUT_REPORT_DISMISS_ERROR';



// WEBPACK FOOTER //
// ./src/features/home/redux/constants.js